export enum AuthenticationType {
  NO_AUTH = 'no_auth',
  PASSWORD = 'password',
  OAUTH_2 = 'oauth_2',
}
